import React from 'react';
import { HiOutlineRefresh, HiOutlineViewList } from 'react-icons/hi';

/**
 * Slim top bar over the transcript: sidebar toggle, conversation title, and a
 * reset action mirroring the sidebar's (kept here because the sidebar is
 * hidden on mobile and while collapsed).
 */
export default function ChatHeader({ title, onToggleSidebar, sidebarOpen, onResetSession }) {
  return (
    <header className="flex h-12 flex-none items-center gap-2 px-3">
      {!sidebarOpen && (
        <button
          type="button"
          onClick={onToggleSidebar}
          aria-label="Open sidebar"
          className="rounded p-1.5 text-ink-faint transition-colors hover:bg-surface hover:text-ink"
        >
          <HiOutlineViewList size={16} />
        </button>
      )}

      <h1 className="min-w-0 flex-1 truncate text-[14px] text-ink-muted">{title}</h1>

      <button
        type="button"
        onClick={onResetSession}
        title="Reset session"
        aria-label="Reset session"
        className="rounded p-1.5 text-ink-faint transition-colors hover:bg-surface hover:text-ink"
      >
        <HiOutlineRefresh size={15} />
      </button>
    </header>
  );
}
